// extracted by mini-css-extract-plugin
export default {"cls1":"SensitiveToggle-Container_cls1__yNYnR","cls2":"SensitiveToggle-Container_cls2__Ri6BR SensitiveToggle-Container_cls1__yNYnR"};